import { SkeletonLoader, H4 } from '@payaca/ambrosia';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC } from 'react';

/**
 * Loading placeholder for a payment-tab options section: a heading followed by
 * two toggle rows. Shared by the payment-method and price-detail option forms
 * so their loading states stay identical.
 */
const OptionsSectionSkeleton: FC<{ title: string; className?: string }> = (
  props
) => {
  const { title, className } = props;

  return (
    <section
      className={clstx('flex flex-col gap-3', className)}
      aria-busy="true"
    >
      <H4>{title}</H4>
      <div className="flex flex-col gap-4">
        {[0, 1].map((i) => (
          <div key={i} className="flex items-center gap-2">
            <SkeletonLoader className="size-4 rounded" />
            <SkeletonLoader className="h-4 w-40 rounded" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default OptionsSectionSkeleton;
